import { Context } from '@/orrm/model/context'
import Wrapper from '@/orrm/wrapper/wrapper'
import LayerWrapper from '@/orrm/wrapper/layer'
import { Layer } from '@/orrm/model/layer'
import { Actualite } from '@/orrm/model/actualite'
import { InfoReglementation } from '@/orrm/model/info-reglementation'
import { Entity } from '@/orrm/model/entity'

export default class ContextWrapper extends Wrapper<Context> {
  icon = 'c'
  layers: LayerWrapper[] = []

  constructor (origin: Context) {
    super(origin)
    const actuLayer = Layer.createFakeLayer({
      title: 'Actualités'
    }, Actualite.layerId)
    const infosLayer = Layer.createFakeLayer({
      title: 'Infos & règlementations locales'
    }, InfoReglementation.layerId)
    const entitiesLayer = Layer.createFakeLayer({
      title: 'Entités'
    }, Entity.layerId)

    const entityLayerWrapper = new LayerWrapper(entitiesLayer, Entity.clusterFeatureStyle)
    entityLayerWrapper.enabled = false

    this.layers.push(
      new LayerWrapper(actuLayer, Actualite.clusterFeatureStyle),
      new LayerWrapper(infosLayer, InfoReglementation.clusterFeatureStyle),
      entityLayerWrapper
    )
    this.layers.push(...this.model.getLayers().map((layer: Layer) => new LayerWrapper(layer)))
  }

  getFakeLayer (uuid: string) {
    return this.layers.find((lw: LayerWrapper) => lw.model.uuid === uuid)
  }
}
